// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import ShopPaymentPagingResultModel from '../../model/shop-payment-paging-result-model';
import ShopPaymentPagingResultDTO from '../dto/shop-payment-paging-result-dto';
import dtoSchema from '../schemas/shop-payment-paging-result-schema';
import ShopPaymentModel from '../../model/shop-payment-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class ShopPaymentPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<ShopPaymentPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => ShopPaymentModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  items?: ShopPaymentModel[];
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  paginationData?: PaginationDataModel;

  static toModel(dto: DeepPartial<ShopPaymentPagingResultDTO>): ShopPaymentPagingResultModel;
  static toModel(dto: DeepPartial<ShopPaymentPagingResultDTO> | undefined | null): ShopPaymentPagingResultModel | undefined;
  static toModel(dto: DeepPartial<ShopPaymentPagingResultDTO> | undefined | null): ShopPaymentPagingResultModel | undefined {
    return dto ? new ShopPaymentPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<ShopPaymentPagingResultModel> | ShopPaymentPagingResultModel): ShopPaymentPagingResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
      paginationData: unwrapped.paginationData,
    } as ShopPaymentPagingResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for ShopPaymentPagingResultModel, can not map to ShopPaymentPagingResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
